module.exports = __webpack_public_path__ + "static/img/21.4f1cec4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/21.png
// module id = at3m
// module chunks = 0